<template>
   <div class="text-center">

    <div class="progress-container">
        <div class="progress rounded-pill">
            <div
                class="progress-bar"
                :class="`bg-${color}`"
                :style="{ width: `${progress}%` }"
                role="progressbar"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>

        </div>
    </div>
    <span class="fw-bold mt-1"  >  {{  progress }}%</span>
   </div>
</template>

<script>
export default {
    props: {
        progress: {
            type: Number,
            required: true,
            validator(value) {
                return value >= 0 && value <= 100;
            }
        }
    },
    computed: {
        color() {
            if (this.progress > 99) {
                return "success";
            } else if (this.progress >= 80) {
                return "primary";
            } else if (this.progress >= 40) {
                return "warning";
            } else {
                return "danger";
            }
        }
    }
}
</script>

<style scoped>
.progress-container {
    width: 100%;
}

.progress {
    height: 10px;
    background-color: #e0e0e0;
}


</style>
